var map = {
	"./Hmera_perivallontos_310X588.jpg": "68d2",
	"./Mundial-webpost_310x588.jpg": "0d8d",
	"./elin2024xmas310x588.png": "227e",
	"./elin_ereuna_ikanopoiisis310X588.jpg": "d0f0",
	"./elinxmas310x588.jpg": "742e",
	"./makeawish_site_310X588.jpg": "ed3e",
	"./newParticipant_ATTIKH_PUSH_1440X720.jpg": "fefe",
	"./pasxa310x588.jpg": "bfb8",
	"./web_500x800.jpg": "464f",
	"./xmas2025.jpg": "7bf9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a9cb";